export default __webpack_public_path__ + "static/media/Cairo-Bold.42ec956b.ttf";